import React from "react";
import { cn } from "@/libs/utils";
import LeftSection from "src/components/legals/LeftSection";
import RightSection from "src/components/legals/RightSection";
import { useTrans } from "src/utils/useTrans";
import type { LegalDocResolved } from "@/libs/legals";
import { formatLegalDate } from "@/libs/legals/format-date";

type Props = {
  doc: LegalDocResolved;
};

const Notice = ({ children }: { children: React.ReactNode }) => (
  <div
    className={cn(
      "mt-8 rounded border border-[#e2e2e2] bg-[#f7f7f7] px-4 py-3",
      "text-sm text-coolgray-70",
    )}
  >
    {children}
  </div>
);

export default function LegalDocument({ doc }: Props) {
  const { t, i18n } = useTrans(["gnb"]);
  // 개정일은 본문이 아니라 frontmatter 에 있다 (src/libs/legals/format-date.ts)
  const updated = formatLegalDate(doc.lastUpdated, i18n.language);

  return (
    <div
      style={{ maxWidth: "calc(1920px - 363px - 363px + 40px)" }}
      className={cn("text-222222 mx-auto w-full bg-white pt-0 sm:pt-[80px]")}
    >
      <div className={"flex flex-col px-5 pt-7.5 smd:flex-row md:pt-0"}>
        <LeftSection
          title={doc.title}
          href={doc.pdfUrl ?? undefined}
          className={"w-full max-w-[378px] smd:w-1/3 smd:max-w-full"}
        />
        <div
          className={"ml-0 w-full max-w-[786px] smd:ml-[30px] smd:max-w-full"}
        >
          {!!updated && (
            <p className={"pt-3 text-sm text-coolgray-70"}>
              {t("Last updated")}: {updated}
            </p>
          )}

          {doc.isFallback && (
            <Notice>
              {t(
                "This document is not available in your language yet. The English version is shown.",
              )}
            </Notice>
          )}

          <RightSection
            isError={false}
            md={doc.contents}
            className={"w-full"}
          />
        </div>
      </div>
    </div>
  );
}
